import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4),
  },
  body: {
    paddingTop: theme.spacing(6),
    fontSize: '0.875rem',
  },
  paragraph: {
    paddingTop: theme.spacing(3),
    fontSize: '0.875rem',
  },
}));

export default useStyles;
